import favicon from "./favicon.png";

export default {
  favicon: favicon,
  title: "PDVend"
};



// WEBPACK FOOTER //
// ./src/assets/head/pdvend/index.js